import React from "react";
import { isTrue } from "Utils/filter";
import { CoursewareListItem } from "API/courseware";
import styles from "./index.module.scss";

interface CoursewareInfoProps {
    data: CoursewareListItem;
}

export default function CoursewareInfo({ data }: CoursewareInfoProps) {
    return (
        <div className={styles.root}>
            <span>{isTrue(data.isDownload) ? "允许" : "禁止"}下载</span>
            {data.sourceFileEntity?.fileSize && (
                <span>{data.sourceFileEntity?.fileSize}</span>
            )}
        </div>
    );
}
